module.exports = __webpack_public_path__ + "static/img/dkwps2-7.605b694.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwps2-7.png
// module id = 406
// module chunks = 0